/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import { ESI_REPORT_INITIAL_STATE } from "./esi-report-constant";

const useESIReportService = () => {
  const [esiReportTableUILoading, setEsiReportTableUILoading] = useState(false);
  const [esiReportInputs, setEsiReportInputs] = useState(ESI_REPORT_INITIAL_STATE)
  const [ESIReportListData, setESIReportListData] = useState([]);
  const { fetchData } = useAPIHandler()
  const [dataFetched, setDataFetched] = useState(false);
  const [loadingAllESIReport, setLoadingAllESIReport] = useState(false);
  const [esiReportPDFData, setEsiReportPDFData] = useState([]);
  const [esiReportSummary, setEsiReportSummary] = useState({})
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("")
  const [organizationInfo, setOrganizationInfo] = useState({})
  const handleChange = (e, name) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
      name = e.target.name
    }
    setEsiReportInputs((prevInfo) => ({
      ...prevInfo,
      [name]: value
    }))
  }
  const { report_month } = esiReportInputs;
  let year, month
  if (report_month) {
    const parts = report_month.split("-");
    year = parts[0];
    month = parts[1];
    if (month.startsWith("0")) {
      month = month.substring(1);
    }
  }
  const fetchAllESIReportEmpList = async () => {
    setEsiReportTableUILoading(true);
    try {
      if (report_month) {
        const url = `/report/esi?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`
        const response = await fetchData({
          url: url,
          method: 'GET',
        });
        setESIReportListData(response?.data?.salary);
        setTotalPages(response?.data?.pagesNumber);
        logger.log(response, "ESIReportListData99")
      }
    } catch (error) {
      setEsiReportTableUILoading(false);
    }
  }
  const fetchAllESIReportData = async () => {
    setLoadingAllESIReport(true);
    try {
      if (report_month) {
        const url = `/report/esi?month=${month}&year=${year}&order_type=ASC`
        const response = await fetchData({
          url: url,
          method: 'GET',
        });
        setEsiReportPDFData(response?.data?.salary);
        // extractAllowances(response?.data?.salary);
        setEsiReportSummary(response?.data?.additional_details)
        setOrganizationInfo(response?.data?.org_details)
        setDataFetched(true)
        logger.log(response?.data, "salaryReportListData99")
      }
      setLoadingAllESIReport(false)
    } catch (error) {
      setLoadingAllESIReport(false)
      logger.log(error);
    }

  }
  useEffect(() => {
    fetchAllESIReportEmpList()
  }, [esiReportInputs, rowsPerPage, currentPage, searchQuery])
  const handleExportClick = async () => {
    await fetchAllESIReportData();
  };
  useEffect(() => {
    handleExportClick()
  }, [esiReportInputs])
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value.target.value));
    setCurrentPage(0);
  };
  return {
    ESIReportListData,
    esiReportInputs,
    handleChange,
    dataFetched,
    handleExportClick,
    loadingAllESIReport,
    esiReportPDFData,
    esiReportSummary,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    organizationInfo
  }
}
export default useESIReportService;